import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Al cambiar de ruta, vuelve arriba del documento (mejor UX al entrar a detalle, carrito, etc.).
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
